export type UseSlpSuspenseState = Ref<boolean>;

export const useSlpSuspenseState = (): UseSlpSuspenseState => {
    return useState('slpSuspense', () => true);
};
